import React, { Component } from "react";
import { Link } from "react-router-dom";
import { debounce } from "lodash";

import { withRequest } from "../../utils/request";
import Pagination from "../general/Pagination";
import Loader from "../general/Loader";
import { getLink } from "../../utils/helpers";

class Empleados extends Component {
    state = {
        empleados: [],
        links: [],
        meta: [],
        tipos: [],
        filtros: {
            buscar: "",
            tipo: "",
            estado: "todos",
        },
        loading: true,
        filtrosQuery: "",
    };

    componentDidMount() {
        this.getEmpleados();
        this.getTipos();
    }

    getEmpleados = async (url = null) => {
        url = url ? url + "&limit=12" : "empleados?limit=12";
        const empleados = await this.props.request(url);

        if (empleados.links) {
            this.setState({
                empleados: empleados.data,
                links: empleados.links,
                meta: empleados.meta,
                loading: false,
            });
        }
    };

    getTipos = async () => {
        const tipos = await this.props.request("tipos", this.signal);

        if (tipos.data && tipos.data.length) {
            this.setState({
                tipos: tipos.data,
            });
        }
    };

    onFiltroChange = debounce(async (value, filtro) => {
        await this.setState({
            filtros: {
                ...this.state.filtros,
                [filtro]: value,
            },
        });

        let query = Object.keys(this.state.filtros).map((fil) => {
            return `${fil}=${this.state.filtros[fil]}`;
        });

        await this.setState({
            filtrosQuery: "?" + query.join("&"),
        });

        this.getEmpleados("empleados?" + query.join("&"));
    }, 500);

    render() {
        const { empleados, loading, tipos, filtrosQuery } = this.state;
        return (
            <div className='container'>
                <div className='page-header'>
                    <h1 className='page-title row'>
                        <span className='col'>Listado de Empleados</span>

                        <div className='dropdown m-r-10'>
                            <button className='au-btn au-btn-icon au-btn-filter'>
                                <i className='zmdi zmdi-print'></i> Imprimir
                            </button>
                            <div
                                style={{ right: "0", left: "auto" }}
                                className='dropdown-menu'>
                                <Link
                                    to={getLink(
                                        `/imprimir/empleados${filtrosQuery}`
                                    )}
                                    target='_blank'
                                    className='dropdown-item'>
                                    {" "}
                                    Listado Empleados
                                </Link>
                                <Link
                                    to={getLink(
                                        `/imprimir/empleados/detalle${filtrosQuery}`
                                    )}
                                    target='_blank'
                                    className='dropdown-item'>
                                    {" "}
                                    Detalle Empleados
                                </Link>
                            </div>
                        </div>
                        <Link
                            to={getLink("/empleados/crear")}
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Empleado
                        </Link>
                    </h1>
                    <div className='page-controls'>
                        <div className='table-data__tool'>
                            <div className='table-data__tool-left row'>
                                <div className='col-md-6'>
                                    <label htmlFor='search'>Buscar</label>
                                    <input
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "buscar"
                                            )
                                        }
                                        type='search'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        name='buscar'
                                    />
                                </div>
                                <div className='col-md-2'>
                                    <label htmlFor='tipo'>Cargo</label>
                                    <select
                                        className='form-control'
                                        name='tipo'
                                        id='tipo'
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "tipo"
                                            )
                                        }>
                                        <option value='-1'>Todos</option>
                                        {tipos.map((tipo) => (
                                            <option
                                                key={tipo.id}
                                                value={tipo.id}>
                                                {tipo.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='col-md-2'>
                                    <label htmlFor='estado'>Estado</label>
                                    <select
                                        className='form-control'
                                        name='estado'
                                        id='estado'
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "estado"
                                            )
                                        }>
                                        <option value='todos'>Todos</option>
                                        <option value='activos'>Activos</option>
                                        <option value='inactivos'>
                                            Inactivos
                                        </option>
                                    </select>
                                </div>
                                <div className='col-md-2'>
                                    <label htmlFor='informal'>Tipo</label>
                                    <select
                                        className='form-control'
                                        name='informal'
                                        id='informal'
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "informal"
                                            )
                                        }>
                                        <option value='todos'>Todos</option>
                                        <option value='formal'>Formal</option>
                                        <option value='informal'>
                                            Informal
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='empleados-list'>
                    {loading && <Loader />}
                    {!empleados.length ? (
                        <div>
                            {!loading && <div>No hay Empleados creados.</div>}
                        </div>
                    ) : (
                        <div className='row'>
                            {empleados.map((empleado) => (
                                <EmpleadoCard
                                    key={empleado.id}
                                    empleado={empleado}
                                />
                            ))}
                            <Pagination
                                links={this.state.links}
                                meta={this.state.meta}
                                getData={this.getEmpleados}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const EmpleadoCard = (props) => {
    const { empleado } = props;
    return (
        <div className='col-md-4'>
            <div
                className={
                    "card empleado-card " +
                    (empleado.active ? "activo" : "inactivo")
                }>
                <div className='card-body'>
                    <div className='row empleado-header'>
                        {empleado.foto && <div className='col-md-3'></div>}
                        <div className='col'>
                            <h3 className='nombre'>
                                {empleado.nombreCompleto}
                                <Link
                                    to={getLink(
                                        `/empleados/${empleado.id}/informacion`
                                    )}
                                    className='item'>
                                    <i className='zmdi zmdi-edit' />
                                </Link>
                            </h3>
                            <div className='cargo'>
                                {empleado.cargo}{" "}
                                {empleado.licencia
                                    ? `- ${empleado.licencia}`
                                    : ""}{" "}
                                {empleado.informal !== 0 && (
                                    <span className='badge badge-warning'>
                                        Informal
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        {empleado.foto && (
                            <div className='col-md-3'>
                                <span className='page-title-foto'>
                                    <img
                                        src={empleado.foto}
                                        alt={empleado.codigo}
                                    />
                                </span>
                            </div>
                        )}
                        <div className='col'>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>
                                            <i className='zmdi zmdi-assignment-account'></i>
                                        </th>
                                        <td>{empleado.cedula}</td>
                                    </tr>
                                    {empleado.telefono && (
                                        <tr>
                                            <th>
                                                <i className='zmdi zmdi-smartphone'></i>
                                            </th>
                                            <td>{empleado.telefono}</td>
                                        </tr>
                                    )}
                                    {empleado.direccion && (
                                        <tr>
                                            <th>
                                                <i className='zmdi zmdi-pin'></i>
                                            </th>
                                            <td>{empleado.direccion}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRequest(Empleados);
